export const agentNamesDataMap = {
  deep_search: "Deep Search",
  literature_search: "Literature Search",
  ocr: "Ocr",
  ai_summary: "Ai Summary",
  speech_to_text_dialization: "Speech to Text – Dialization",
  speech_to_text_translate: "Speech to Text – Translate",
  speech_to_text_normal: "Speech to Text – Normal",
  ai_analysis: "Ai analysis",
}
